var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDisplayAdsWithBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.8494 30.0454C59.4413 42.4356 63.645 59.8964 45.4835 59.5284C38.2188 59.9373 30.9134 60.1009 23.608 59.9373C12.7519 59.8146 -0.552995 60.2645 0.0183796 45.5843C0.0183796 34.9115 0.0183796 24.2388 0.0183796 13.566C-0.348933 6.94157 4.83425 0.889588 11.5275 0.644237C19.5675 0.112644 27.6484 -0.132707 35.6885 0.071752C62.4614 -0.582516 60.0127 7.10514 59.8494 30.0454Z",
    fill: "#469D7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.875 24.5V21.875C37.875 20.4253 36.6997 19.25 35.25 19.25H19.5C18.0503 19.25 16.875 20.4253 16.875 21.875V27.125C16.875 28.5747 18.0503 29.75 19.5 29.75H28.6875M45.75 27.125V16.625C45.75 15.1753 44.5747 14 43.125 14H11.625C10.1753 14 9 15.1753 9 16.625V37.625C9 39.0747 10.1753 40.25 11.625 40.25H29.6719M44.21 38.71L41.97 45.5L35.25 29.75L51 36.47L44.21 38.71Z",
    stroke: "#373F41",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDisplayAdsWithBg);
export default __webpack_public_path__ + "static/media/IconDisplayAdsWithBG.bfe62e7e4ee91a267ff7e8569dc1fd64.svg";
export { ForwardRef as ReactComponent };